package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.outlined.Cancel
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.ModalBottomSheet
import androidx.compose.material3.Text
import androidx.compose.material3.rememberModalBottomSheetState
import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.material3.windowsizeclass.WindowWidthSizeClass
import androidx.compose.material3.windowsizeclass.calculateWindowSizeClass
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import co.touchlab.kermit.Logger
import kotlinx.coroutines.delay
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.JoinQueueData
import tta.destinigo.talktoastro.shared.data.ButtonStatus
import tta.destinigo.talktoastro.shared.data.QueueOption
import tta.destinigo.talktoastro.shared.local.ConfigProvider
import tta.destinigo.talktoastro.shared.persentation.CommonLoadingButton
import tta.destinigo.talktoastro.shared.platform.showToast
import tta.destinigo.talktoastro.shared.remote.Resources
import tta.destinigo.talktoastro.shared.theme.Scale
import tta.destinigo.talktoastro.shared.theme.primaryDark

@OptIn(ExperimentalMaterial3Api::class, ExperimentalMaterial3WindowSizeClassApi::class)
@Composable
fun JoinQueueBottomSheet(
    component: QueueComponent,
) {
    val windowSizeClass = calculateWindowSizeClass().widthSizeClass
    val queueType = component.queueType.collectAsState()
    val joinQueueState = component.joinQueueState.collectAsState()

//    LaunchedEffect(joinQueueState.value) {
//        if (joinQueueState.value is Resources.Success) {
//            ConfigProvider.setQueueStatus(true)
//            delay(1200)
//            component.onDismiss.invoke(true)
//        }
//    }
    LaunchedEffect(joinQueueState.value) {
        if (joinQueueState.value is Resources.Success) {
            ConfigProvider.setQueueStatus(true)
            showToast("Success! You’re in the queue. We’ll notify you when it’s your turn — just go to the Home page to start.")
            delay(1200)
            component.onDismiss.invoke(true)
        }
    }


    LaunchedEffect(joinQueueState.value) {
        val state = joinQueueState.value
        if (state is Resources.Error) {
            co.touchlab.kermit.Logger.d { "joinQueueState Error" }
            ConfigProvider.setQueueStatus(false)

            val errorMessage = state.msg?.takeIf { it.contains("Insufficient balance", ignoreCase = true) }
                ?.let { "Insufficient balance. Please recharge the wallet." }
                ?: state.msg ?: "Unexpected Error"

            showToast(errorMessage)
            delay(1200)
            component.onDismiss(false)
        }
    }

    val content: @Composable () -> Unit = {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            Row(
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    text = "Join Queue",
                    style = MaterialTheme.typography.headlineSmall,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier.weight(1f),
                    textAlign = TextAlign.Start
                )

                IconButton(
                    modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE_MAX).alpha(0.2f),
                    onClick = { component.onDismiss.invoke(false) }
                ) {
                    Icon(
                        imageVector = Icons.Outlined.Cancel,
                        contentDescription = "Close Icon"
                    )
                }
            }

            Spacer(modifier = Modifier.height(16.dp))

            // Call (Online) Option
            QueueOptionCard(
                title = when (component.callConsultationData.isOnline) {
                    ButtonStatus.ONLINE -> "Call(Online)"
                    ButtonStatus.OFFLINE -> "Call(Offline)"
                    ButtonStatus.BUSY -> "Call(Busy)"
                },
                // title = if (component.callConsultationData.isOnline) "Call(Online)" else "Call(Offline)",
                queueNo = component.callConsultationData.queueNo,
                waitTime = component.callConsultationData.waitTime,
                isSelected = (queueType.value == QueueOption.CALL),
                isAvailable = component.callConsultationData.isOnline != ButtonStatus.OFFLINE,
                onSelect = { component.onOptionSelected(QueueOption.CALL) },
                buttonStatus = component.callConsultationData.isOnline
            )

            Logger.d { "call option ${component.callConsultationData.isOnline}" }
            Logger.d { "chat option ${component.chatConsultationData.isOnline}" }

            Spacer(modifier = Modifier.height(12.dp))

            // Chat (Offline) Option
            QueueOptionCard(
                title = when (component.chatConsultationData.isOnline) {
                    ButtonStatus.ONLINE -> "Chat(Online)"
                    ButtonStatus.OFFLINE -> "Chat(Offline)"
                    ButtonStatus.BUSY -> "Chat(Busy)"
                },
                //title = if (component.chatConsultationData.isOnline) "Chat(Online)" else "Chat(Offline)",
                queueNo = component.chatConsultationData.queueNo,
                waitTime = component.chatConsultationData.waitTime,
                isSelected = (queueType.value == QueueOption.CHAT),
                isAvailable = component.chatConsultationData.isOnline != ButtonStatus.OFFLINE,
                onSelect = { component.onOptionSelected(QueueOption.CHAT) },
                buttonStatus = component.chatConsultationData.isOnline
            )

            Spacer(modifier = Modifier.height(12.dp))

            // Info Message
            Card(
                colors = CardDefaults.cardColors(containerColor = primaryDark.copy(alpha = 0.1f)),
                modifier = Modifier.fillMaxWidth()
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.padding(12.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.Info,
                        contentDescription = "Info",
                        tint = primaryDark,
                        modifier = Modifier.size(Scale.GLOBAL_ICON_SIZE_SMALL)
                    )
                    Spacer(modifier = Modifier.width(8.dp))
                    Text(
                        text = "${component.commonExpertInfo.expertName} is actively taking calls now. Join call for quicker consultation",
                        style = MaterialTheme.typography.labelMedium,
                        fontWeight = FontWeight.SemiBold
                    )
                }
            }

            Spacer(modifier = Modifier.height(16.dp))

            // Join Queue Button
            CommonLoadingButton(
                text = if (joinQueueState.value is Resources.Success) "Success ! Queue Position ${(joinQueueState.value as Resources.Success<JoinQueueData>).data?.queuePosition}" else "Join Queue immediately",
                isLoading = (joinQueueState.value is Resources.Loading),
                onClick = {
                    component.onJoinQueue()
                },
                modifier = Modifier.fillMaxWidth()
            )
        }
    }

    if (windowSizeClass == WindowWidthSizeClass.Compact) {

        val sheetState = rememberModalBottomSheetState(skipPartiallyExpanded = true)
        // Use BottomSheet for Compact screens
        ModalBottomSheet(
            sheetState = sheetState,
            containerColor = Color.White,
            onDismissRequest = { component.onDismiss.invoke(false) }
        ) {
            Box(
                modifier = Modifier.fillMaxWidth().padding(top = 16.dp, bottom = 30.dp, start = 16.dp, end = 16.dp)
            ) {
                content.invoke()
            }
        }
    } else {
        AlertDialog(
            containerColor = Color.White,
            onDismissRequest = {
                component.onDismiss.invoke(false)
            },
            text = {
                content.invoke()
            },
            shape = RoundedCornerShape(Scale.CORNER_SMALL),
            confirmButton = {},
            dismissButton = {
                component.onDismiss
            }
        )
    }

}
